"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_EPOINTAGE_SCHEDULER = void 0;
const client_1 = require("@apollo/client");
exports.UPDATE_EPOINTAGE_SCHEDULER = client_1.gql `
mutation updateEPointageScheduler (
  $siteId: String!
  $etaId: String!
  $claId: String!
  $scheduleId: Int!
  $isInvoice: Boolean
  $scheduleNumberDay: Int
  $scheduleDeadline: String
  $checkingDay: String!
  $updateUser: Int!
  $updateDate: String!
  $students: [EPointageSchedulerStudentsInput]
){
  scheduler: updateEPointageScheduler(
      siteId: $siteId
      etaId: $etaId
      claId: $claId
      scheduleId: $scheduleId
      isInvoice: $isInvoice
      scheduleNumberDay: $scheduleNumberDay
      scheduleDeadline: $scheduleDeadline
      checkingDay: $checkingDay
      updateUser: $updateUser
      updateDate: $updateDate
      students: $students
  ){
      scheduleId
      isInvoice
      scheduleNumberDay
      scheduleDeadline
      checkingDay
      updateUser
      updateDate
  }
}
`;
